/**
 * @fileoverview gRPC-Web generated client stub for Auth
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.Auth = require('./authClient_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.Auth.AuthServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.Auth.AuthServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Auth.LoginRequest,
 *   !proto.Auth.LoginResponse>}
 */
const methodDescriptor_AuthService_userLogin = new grpc.web.MethodDescriptor(
  '/Auth.AuthService/userLogin',
  grpc.web.MethodType.UNARY,
  proto.Auth.LoginRequest,
  proto.Auth.LoginResponse,
  /**
   * @param {!proto.Auth.LoginRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Auth.LoginResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.Auth.LoginRequest,
 *   !proto.Auth.LoginResponse>}
 */
const methodInfo_AuthService_userLogin = new grpc.web.AbstractClientBase.MethodInfo(
  proto.Auth.LoginResponse,
  /**
   * @param {!proto.Auth.LoginRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Auth.LoginResponse.deserializeBinary
);


/**
 * @param {!proto.Auth.LoginRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.Auth.LoginResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Auth.LoginResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Auth.AuthServiceClient.prototype.userLogin =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Auth.AuthService/userLogin',
      request,
      metadata || {},
      methodDescriptor_AuthService_userLogin,
      callback);
};


/**
 * @param {!proto.Auth.LoginRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Auth.LoginResponse>}
 *     A native promise that resolves to the response
 */
proto.Auth.AuthServicePromiseClient.prototype.userLogin =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Auth.AuthService/userLogin',
      request,
      metadata || {},
      methodDescriptor_AuthService_userLogin);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Auth.OutRequest,
 *   !proto.Auth.OutResponse>}
 */
const methodDescriptor_AuthService_logOut = new grpc.web.MethodDescriptor(
  '/Auth.AuthService/logOut',
  grpc.web.MethodType.UNARY,
  proto.Auth.OutRequest,
  proto.Auth.OutResponse,
  /**
   * @param {!proto.Auth.OutRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Auth.OutResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.Auth.OutRequest,
 *   !proto.Auth.OutResponse>}
 */
const methodInfo_AuthService_logOut = new grpc.web.AbstractClientBase.MethodInfo(
  proto.Auth.OutResponse,
  /**
   * @param {!proto.Auth.OutRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Auth.OutResponse.deserializeBinary
);


/**
 * @param {!proto.Auth.OutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.Auth.OutResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Auth.OutResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Auth.AuthServiceClient.prototype.logOut =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Auth.AuthService/logOut',
      request,
      metadata || {},
      methodDescriptor_AuthService_logOut,
      callback);
};


/**
 * @param {!proto.Auth.OutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Auth.OutResponse>}
 *     A native promise that resolves to the response
 */
proto.Auth.AuthServicePromiseClient.prototype.logOut =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Auth.AuthService/logOut',
      request,
      metadata || {},
      methodDescriptor_AuthService_logOut);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Auth.RegisterRequest,
 *   !proto.Auth.RegisterResponse>}
 */
const methodDescriptor_AuthService_userRegister = new grpc.web.MethodDescriptor(
  '/Auth.AuthService/userRegister',
  grpc.web.MethodType.UNARY,
  proto.Auth.RegisterRequest,
  proto.Auth.RegisterResponse,
  /**
   * @param {!proto.Auth.RegisterRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Auth.RegisterResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.Auth.RegisterRequest,
 *   !proto.Auth.RegisterResponse>}
 */
const methodInfo_AuthService_userRegister = new grpc.web.AbstractClientBase.MethodInfo(
  proto.Auth.RegisterResponse,
  /**
   * @param {!proto.Auth.RegisterRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Auth.RegisterResponse.deserializeBinary
);


/**
 * @param {!proto.Auth.RegisterRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.Auth.RegisterResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Auth.RegisterResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Auth.AuthServiceClient.prototype.userRegister =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Auth.AuthService/userRegister',
      request,
      metadata || {},
      methodDescriptor_AuthService_userRegister,
      callback);
};


/**
 * @param {!proto.Auth.RegisterRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Auth.RegisterResponse>}
 *     A native promise that resolves to the response
 */
proto.Auth.AuthServicePromiseClient.prototype.userRegister =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Auth.AuthService/userRegister',
      request,
      metadata || {},
      methodDescriptor_AuthService_userRegister);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Auth.CheckUserNameRequest,
 *   !proto.Auth.CheckUserNameResponse>}
 */
const methodDescriptor_AuthService_checkUserName = new grpc.web.MethodDescriptor(
  '/Auth.AuthService/checkUserName',
  grpc.web.MethodType.UNARY,
  proto.Auth.CheckUserNameRequest,
  proto.Auth.CheckUserNameResponse,
  /**
   * @param {!proto.Auth.CheckUserNameRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Auth.CheckUserNameResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.Auth.CheckUserNameRequest,
 *   !proto.Auth.CheckUserNameResponse>}
 */
const methodInfo_AuthService_checkUserName = new grpc.web.AbstractClientBase.MethodInfo(
  proto.Auth.CheckUserNameResponse,
  /**
   * @param {!proto.Auth.CheckUserNameRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Auth.CheckUserNameResponse.deserializeBinary
);


/**
 * @param {!proto.Auth.CheckUserNameRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.Auth.CheckUserNameResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Auth.CheckUserNameResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Auth.AuthServiceClient.prototype.checkUserName =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Auth.AuthService/checkUserName',
      request,
      metadata || {},
      methodDescriptor_AuthService_checkUserName,
      callback);
};


/**
 * @param {!proto.Auth.CheckUserNameRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Auth.CheckUserNameResponse>}
 *     A native promise that resolves to the response
 */
proto.Auth.AuthServicePromiseClient.prototype.checkUserName =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Auth.AuthService/checkUserName',
      request,
      metadata || {},
      methodDescriptor_AuthService_checkUserName);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Auth.CheckPhoneRequest,
 *   !proto.Auth.CheckPhoneResponse>}
 */
const methodDescriptor_AuthService_checkPhone = new grpc.web.MethodDescriptor(
  '/Auth.AuthService/checkPhone',
  grpc.web.MethodType.UNARY,
  proto.Auth.CheckPhoneRequest,
  proto.Auth.CheckPhoneResponse,
  /**
   * @param {!proto.Auth.CheckPhoneRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Auth.CheckPhoneResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.Auth.CheckPhoneRequest,
 *   !proto.Auth.CheckPhoneResponse>}
 */
const methodInfo_AuthService_checkPhone = new grpc.web.AbstractClientBase.MethodInfo(
  proto.Auth.CheckPhoneResponse,
  /**
   * @param {!proto.Auth.CheckPhoneRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Auth.CheckPhoneResponse.deserializeBinary
);


/**
 * @param {!proto.Auth.CheckPhoneRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.Auth.CheckPhoneResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Auth.CheckPhoneResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Auth.AuthServiceClient.prototype.checkPhone =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Auth.AuthService/checkPhone',
      request,
      metadata || {},
      methodDescriptor_AuthService_checkPhone,
      callback);
};


/**
 * @param {!proto.Auth.CheckPhoneRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Auth.CheckPhoneResponse>}
 *     A native promise that resolves to the response
 */
proto.Auth.AuthServicePromiseClient.prototype.checkPhone =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Auth.AuthService/checkPhone',
      request,
      metadata || {},
      methodDescriptor_AuthService_checkPhone);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Auth.ValicodeRequest,
 *   !proto.Auth.ValicodeResponse>}
 */
const methodDescriptor_AuthService_getValicode = new grpc.web.MethodDescriptor(
  '/Auth.AuthService/getValicode',
  grpc.web.MethodType.UNARY,
  proto.Auth.ValicodeRequest,
  proto.Auth.ValicodeResponse,
  /**
   * @param {!proto.Auth.ValicodeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Auth.ValicodeResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.Auth.ValicodeRequest,
 *   !proto.Auth.ValicodeResponse>}
 */
const methodInfo_AuthService_getValicode = new grpc.web.AbstractClientBase.MethodInfo(
  proto.Auth.ValicodeResponse,
  /**
   * @param {!proto.Auth.ValicodeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Auth.ValicodeResponse.deserializeBinary
);


/**
 * @param {!proto.Auth.ValicodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.Auth.ValicodeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Auth.ValicodeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Auth.AuthServiceClient.prototype.getValicode =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Auth.AuthService/getValicode',
      request,
      metadata || {},
      methodDescriptor_AuthService_getValicode,
      callback);
};


/**
 * @param {!proto.Auth.ValicodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Auth.ValicodeResponse>}
 *     A native promise that resolves to the response
 */
proto.Auth.AuthServicePromiseClient.prototype.getValicode =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Auth.AuthService/getValicode',
      request,
      metadata || {},
      methodDescriptor_AuthService_getValicode);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Auth.UserStatusRequest,
 *   !proto.Auth.UserStatusResponse>}
 */
const methodDescriptor_AuthService_getUserStatus = new grpc.web.MethodDescriptor(
  '/Auth.AuthService/getUserStatus',
  grpc.web.MethodType.UNARY,
  proto.Auth.UserStatusRequest,
  proto.Auth.UserStatusResponse,
  /**
   * @param {!proto.Auth.UserStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Auth.UserStatusResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.Auth.UserStatusRequest,
 *   !proto.Auth.UserStatusResponse>}
 */
const methodInfo_AuthService_getUserStatus = new grpc.web.AbstractClientBase.MethodInfo(
  proto.Auth.UserStatusResponse,
  /**
   * @param {!proto.Auth.UserStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Auth.UserStatusResponse.deserializeBinary
);


/**
 * @param {!proto.Auth.UserStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.Auth.UserStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Auth.UserStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Auth.AuthServiceClient.prototype.getUserStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Auth.AuthService/getUserStatus',
      request,
      metadata || {},
      methodDescriptor_AuthService_getUserStatus,
      callback);
};


/**
 * @param {!proto.Auth.UserStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Auth.UserStatusResponse>}
 *     A native promise that resolves to the response
 */
proto.Auth.AuthServicePromiseClient.prototype.getUserStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Auth.AuthService/getUserStatus',
      request,
      metadata || {},
      methodDescriptor_AuthService_getUserStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Auth.UserPowerRequest,
 *   !proto.Auth.UserPowerResponse>}
 */
const methodDescriptor_AuthService_checkUserPower = new grpc.web.MethodDescriptor(
  '/Auth.AuthService/checkUserPower',
  grpc.web.MethodType.UNARY,
  proto.Auth.UserPowerRequest,
  proto.Auth.UserPowerResponse,
  /**
   * @param {!proto.Auth.UserPowerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Auth.UserPowerResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.Auth.UserPowerRequest,
 *   !proto.Auth.UserPowerResponse>}
 */
const methodInfo_AuthService_checkUserPower = new grpc.web.AbstractClientBase.MethodInfo(
  proto.Auth.UserPowerResponse,
  /**
   * @param {!proto.Auth.UserPowerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Auth.UserPowerResponse.deserializeBinary
);


/**
 * @param {!proto.Auth.UserPowerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.Auth.UserPowerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Auth.UserPowerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Auth.AuthServiceClient.prototype.checkUserPower =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Auth.AuthService/checkUserPower',
      request,
      metadata || {},
      methodDescriptor_AuthService_checkUserPower,
      callback);
};


/**
 * @param {!proto.Auth.UserPowerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Auth.UserPowerResponse>}
 *     A native promise that resolves to the response
 */
proto.Auth.AuthServicePromiseClient.prototype.checkUserPower =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Auth.AuthService/checkUserPower',
      request,
      metadata || {},
      methodDescriptor_AuthService_checkUserPower);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Auth.UserIpRequest,
 *   !proto.Auth.UserIpResponse>}
 */
const methodDescriptor_AuthService_getUserIp = new grpc.web.MethodDescriptor(
  '/Auth.AuthService/getUserIp',
  grpc.web.MethodType.UNARY,
  proto.Auth.UserIpRequest,
  proto.Auth.UserIpResponse,
  /**
   * @param {!proto.Auth.UserIpRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Auth.UserIpResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.Auth.UserIpRequest,
 *   !proto.Auth.UserIpResponse>}
 */
const methodInfo_AuthService_getUserIp = new grpc.web.AbstractClientBase.MethodInfo(
  proto.Auth.UserIpResponse,
  /**
   * @param {!proto.Auth.UserIpRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Auth.UserIpResponse.deserializeBinary
);


/**
 * @param {!proto.Auth.UserIpRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.Auth.UserIpResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Auth.UserIpResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Auth.AuthServiceClient.prototype.getUserIp =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Auth.AuthService/getUserIp',
      request,
      metadata || {},
      methodDescriptor_AuthService_getUserIp,
      callback);
};


/**
 * @param {!proto.Auth.UserIpRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Auth.UserIpResponse>}
 *     A native promise that resolves to the response
 */
proto.Auth.AuthServicePromiseClient.prototype.getUserIp =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Auth.AuthService/getUserIp',
      request,
      metadata || {},
      methodDescriptor_AuthService_getUserIp);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Auth.PhoneCodeRequest,
 *   !proto.Auth.PhoneCodeResponse>}
 */
const methodDescriptor_AuthService_sendPhoneCode = new grpc.web.MethodDescriptor(
  '/Auth.AuthService/sendPhoneCode',
  grpc.web.MethodType.UNARY,
  proto.Auth.PhoneCodeRequest,
  proto.Auth.PhoneCodeResponse,
  /**
   * @param {!proto.Auth.PhoneCodeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Auth.PhoneCodeResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.Auth.PhoneCodeRequest,
 *   !proto.Auth.PhoneCodeResponse>}
 */
const methodInfo_AuthService_sendPhoneCode = new grpc.web.AbstractClientBase.MethodInfo(
  proto.Auth.PhoneCodeResponse,
  /**
   * @param {!proto.Auth.PhoneCodeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Auth.PhoneCodeResponse.deserializeBinary
);


/**
 * @param {!proto.Auth.PhoneCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.Auth.PhoneCodeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Auth.PhoneCodeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Auth.AuthServiceClient.prototype.sendPhoneCode =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Auth.AuthService/sendPhoneCode',
      request,
      metadata || {},
      methodDescriptor_AuthService_sendPhoneCode,
      callback);
};


/**
 * @param {!proto.Auth.PhoneCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Auth.PhoneCodeResponse>}
 *     A native promise that resolves to the response
 */
proto.Auth.AuthServicePromiseClient.prototype.sendPhoneCode =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Auth.AuthService/sendPhoneCode',
      request,
      metadata || {},
      methodDescriptor_AuthService_sendPhoneCode);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Auth.PhoneLoginRequest,
 *   !proto.Auth.LoginResponse>}
 */
const methodDescriptor_AuthService_phoneLogin = new grpc.web.MethodDescriptor(
  '/Auth.AuthService/phoneLogin',
  grpc.web.MethodType.UNARY,
  proto.Auth.PhoneLoginRequest,
  proto.Auth.LoginResponse,
  /**
   * @param {!proto.Auth.PhoneLoginRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Auth.LoginResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.Auth.PhoneLoginRequest,
 *   !proto.Auth.LoginResponse>}
 */
const methodInfo_AuthService_phoneLogin = new grpc.web.AbstractClientBase.MethodInfo(
  proto.Auth.LoginResponse,
  /**
   * @param {!proto.Auth.PhoneLoginRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Auth.LoginResponse.deserializeBinary
);


/**
 * @param {!proto.Auth.PhoneLoginRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.Auth.LoginResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Auth.LoginResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Auth.AuthServiceClient.prototype.phoneLogin =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Auth.AuthService/phoneLogin',
      request,
      metadata || {},
      methodDescriptor_AuthService_phoneLogin,
      callback);
};


/**
 * @param {!proto.Auth.PhoneLoginRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Auth.LoginResponse>}
 *     A native promise that resolves to the response
 */
proto.Auth.AuthServicePromiseClient.prototype.phoneLogin =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Auth.AuthService/phoneLogin',
      request,
      metadata || {},
      methodDescriptor_AuthService_phoneLogin);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Auth.CheckPhoneCodeRequest,
 *   !proto.Auth.CheckPhoneCodeResponse>}
 */
const methodDescriptor_AuthService_checkPhoneCode = new grpc.web.MethodDescriptor(
  '/Auth.AuthService/checkPhoneCode',
  grpc.web.MethodType.UNARY,
  proto.Auth.CheckPhoneCodeRequest,
  proto.Auth.CheckPhoneCodeResponse,
  /**
   * @param {!proto.Auth.CheckPhoneCodeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Auth.CheckPhoneCodeResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.Auth.CheckPhoneCodeRequest,
 *   !proto.Auth.CheckPhoneCodeResponse>}
 */
const methodInfo_AuthService_checkPhoneCode = new grpc.web.AbstractClientBase.MethodInfo(
  proto.Auth.CheckPhoneCodeResponse,
  /**
   * @param {!proto.Auth.CheckPhoneCodeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Auth.CheckPhoneCodeResponse.deserializeBinary
);


/**
 * @param {!proto.Auth.CheckPhoneCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.Auth.CheckPhoneCodeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Auth.CheckPhoneCodeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Auth.AuthServiceClient.prototype.checkPhoneCode =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Auth.AuthService/checkPhoneCode',
      request,
      metadata || {},
      methodDescriptor_AuthService_checkPhoneCode,
      callback);
};


/**
 * @param {!proto.Auth.CheckPhoneCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Auth.CheckPhoneCodeResponse>}
 *     A native promise that resolves to the response
 */
proto.Auth.AuthServicePromiseClient.prototype.checkPhoneCode =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Auth.AuthService/checkPhoneCode',
      request,
      metadata || {},
      methodDescriptor_AuthService_checkPhoneCode);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.Auth.ResetPasswordRequest,
 *   !proto.Auth.ResetPasswordResponse>}
 */
const methodDescriptor_AuthService_resetPassword = new grpc.web.MethodDescriptor(
  '/Auth.AuthService/resetPassword',
  grpc.web.MethodType.UNARY,
  proto.Auth.ResetPasswordRequest,
  proto.Auth.ResetPasswordResponse,
  /**
   * @param {!proto.Auth.ResetPasswordRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Auth.ResetPasswordResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.Auth.ResetPasswordRequest,
 *   !proto.Auth.ResetPasswordResponse>}
 */
const methodInfo_AuthService_resetPassword = new grpc.web.AbstractClientBase.MethodInfo(
  proto.Auth.ResetPasswordResponse,
  /**
   * @param {!proto.Auth.ResetPasswordRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.Auth.ResetPasswordResponse.deserializeBinary
);


/**
 * @param {!proto.Auth.ResetPasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.Auth.ResetPasswordResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.Auth.ResetPasswordResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.Auth.AuthServiceClient.prototype.resetPassword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/Auth.AuthService/resetPassword',
      request,
      metadata || {},
      methodDescriptor_AuthService_resetPassword,
      callback);
};


/**
 * @param {!proto.Auth.ResetPasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.Auth.ResetPasswordResponse>}
 *     A native promise that resolves to the response
 */
proto.Auth.AuthServicePromiseClient.prototype.resetPassword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/Auth.AuthService/resetPassword',
      request,
      metadata || {},
      methodDescriptor_AuthService_resetPassword);
};


module.exports = proto.Auth;

